document.addEventListener('DOMContentLoaded', () => {
    const btnOneColumn = document.querySelector('.change-grid-button__onecollumn');
    const btnTwoColumn = document.querySelector('.change-grid-button__twocolumn');
    const productList = document.querySelector('body');
  
    let clickHandlersAdded = false;
  
    const applyPreference = () => {
      const pref = sessionStorage.getItem('gridView');
      if (pref === 'one') {
        btnOneColumn.classList.add('active');
        btnTwoColumn.classList.remove('active');
        productList.classList.add('grid_onecollumn');
      } else {
        btnTwoColumn.classList.add('active');
        btnOneColumn.classList.remove('active');
        productList.classList.remove('grid_onecollumn');
      }
    };
  
    const handleResize = () => {
      if (window.innerWidth < 1000) {
        if (!clickHandlersAdded) {
          btnOneColumn.addEventListener('click', oneColumnHandler);
          btnTwoColumn.addEventListener('click', twoColumnHandler);
          clickHandlersAdded = true;
        }
      } else {
        if (clickHandlersAdded) {
          btnOneColumn.removeEventListener('click', oneColumnHandler);
          btnTwoColumn.removeEventListener('click', twoColumnHandler);
          clickHandlersAdded = false;
        }
      }
    };
  
    const oneColumnHandler = () => {
      if (!btnOneColumn.classList.contains('active')) {
        btnOneColumn.classList.add('active');
        btnTwoColumn.classList.remove('active');
        productList.classList.add('grid_onecollumn');
        sessionStorage.setItem('gridView', 'one');
      }
    };
  
    const twoColumnHandler = () => {
      if (!btnTwoColumn.classList.contains('active')) {
        btnTwoColumn.classList.add('active');
        btnOneColumn.classList.remove('active');
        productList.classList.remove('grid_onecollumn');
        sessionStorage.setItem('gridView', 'two');
      }
    };
  
    applyPreference();
    handleResize();
    window.addEventListener('resize', handleResize);
  });

// Função para monitorar o estado do Doofinder e gerenciar classe active no botão de busca
document.addEventListener('DOMContentLoaded', () => {
  const searchButton = document.querySelector('.header__main-nav-search--btn');
  const searchDrawerIcon = document.querySelector('.search-drawer--icon');
  
  if (searchButton || searchDrawerIcon) {
    // Função para verificar se o Doofinder está aberto
    const isDoofinderOpen = () => {
      const doofinderRoot = document.querySelector('.dfd-root');
      return doofinderRoot && doofinderRoot.classList.contains('dfd-animate');
    };
    
    // Função para atualizar o estado dos botões
    const updateSearchButtonState = () => {
      const isOpen = isDoofinderOpen();
      
      if (searchButton) {
        if (isOpen) {
          searchButton.classList.add('active');
        } else {
          searchButton.classList.remove('active');
        }
      }
      
      if (searchDrawerIcon) {
        if (isOpen) {
          searchDrawerIcon.classList.add('active');
        } else {
          searchDrawerIcon.classList.remove('active');
        }
      }
    };
    
    // Observer para monitorar mudanças na div do Doofinder
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          updateSearchButtonState();
        }
      });
    });
    
    // Iniciar o observer quando o Doofinder estiver disponível
    const startObserver = () => {
      const doofinderRoot = document.querySelector('.dfd-root');
      if (doofinderRoot) {
        observer.observe(doofinderRoot, {
          attributes: true,
          attributeFilter: ['class']
        });
        updateSearchButtonState(); // Verificar estado inicial
      } else {
        // Se o Doofinder ainda não estiver carregado, tentar novamente em breve
        setTimeout(startObserver, 100);
      }
    };
    
    // Iniciar o monitoramento
    startObserver();
    
    // Também verificar periodicamente para casos onde o Doofinder é carregado dinamicamente
    setInterval(() => {
      const doofinderRoot = document.querySelector('.dfd-root');
      if (doofinderRoot && !observer.takeRecords().length) {
        // Se o Doofinder existe mas o observer não está ativo, reiniciar
        observer.disconnect();
        startObserver();
      }
    }, 1000);
  }
});

// PDP: hide sticky quick-add while main CTA is visible
document.addEventListener('DOMContentLoaded', () => {
  const quickAdds = document.querySelectorAll('product-quick-add[form]');

  if (!quickAdds.length) {
    return;
  }

  const isElementVisibleInViewport = (element) => {
    if (!element) {
      return false;
    }

    const style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) {
      return false;
    }

    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
  };

  quickAdds.forEach((quickAdd) => {
    const formId = quickAdd.getAttribute('form');
    const form = formId ? document.getElementById(formId) : null;
    const mainSubmitCta = form ? form.querySelector('button[type="submit"]') : null;

    if (!mainSubmitCta) {
      return;
    }

    const syncStickyVisibility = () => {
      quickAdd.style.display = isElementVisibleInViewport(mainSubmitCta) ? 'none' : '';
    };

    const observer = new IntersectionObserver(() => {
      syncStickyVisibility();
    }, {
      threshold: [0, 0.01, 0.1]
    });

    observer.observe(mainSubmitCta);
    syncStickyVisibility();
  });
});
  